<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div class="animation-sheet">
      <h1 class="title mb-5">
        <span v-html="currentFiche.titre"></span>
        <br aria-hidden="true" />
        <small v-if="ficheId != undefined"><em>Fiches pour animer une communauté d’apprentissage professionnelle (CAP)</em></small>
        <small v-if="allerPlusLoinId != undefined"><em>Ressources pour aller plus loin</em></small>
      </h1>

      <!-- Section -->
      <div class="section-container" v-for="(section, sectionIndex) in currentFiche.sections" :key="'section' + sectionIndex">
        <span class="section-num" aria-hidden="true">{{ sectionIndex + 1 }}</span>
        <div class="section-area">
          <!-- .titre -->
          <h2 v-html="section.titre"></h2>
          <div class="row">
            <div :class="{ 'col-12 col-md-8 col-lg-9': section.imageSrc, 'col-12': !section.imageSrc }">
              <!-- .bullets -->
              <ul v-if="section.bullets">
                <li v-for="(bullet, bulletIndex) in section.bullets" :key="bulletIndex" v-html="bullet"></li>
              </ul>

              <!-- .linkBullets -->
              <ul v-if="section.linkBullets">
                <li v-for="(bullet, bulletIndex) in section.linkBullets" :key="bulletIndex"><a :href="bullet.link" target="_blank" v-html="bullet.text"> </a></li>
              </ul>

              <!-- .html -->
              <div v-if="section.html" v-html="section.html"></div>

              <!-- .fullscreenImageSrc -->
              <div class="row mt-3" v-if="section.fullscreenImageSrc">
                <div class="col-12 col-md-10 mx-auto">
                  <img class="img-fluid corner-cutted" :src="section.fullscreenImageSrc" :alt="section.fullscreenImageAlt" />
                </div>
              </div>

              <!-- .video -->
              <div class="row video-section" v-if="section.video">
                <div class="col-12 mx-auto">
                  <p v-html="section.video.titre"></p>
                  <!-- <div class="embed-responsive embed-responsive-16by9"> -->
                  <VideoPlayer ref="videoPlayerRef" class="centered-element video-element" :youtube="section.video.isYoutubeVideo" :url="section.video.videoUrl" :poster="section.video.poster" :transcription="section.video.transcription"></VideoPlayer>
                  <!-- </div> -->
                </div>
              </div>
              <!-- .attachement -->
              <div class="row attachement" v-if="section.attachement">
                <div class="col-12 col-md-10 mx-auto">
                  <h3>L'attachement</h3>
                  <img class="img-fluid corner-cutted" :src="section.attachement.imageSrc" :alt="section.attachement.imageAlt" />
                </div>
              </div>

              <!-- .defis -->
              <div class="defi-wrapper">
                <div class="row defi-box" v-for="(defi, defiIndex) in section.defis" :key="defiIndex">
                  <div class="d-none d-md-block col-md-3 col-lg-2">
                    <!-- .imageSrc .imageAlt -->
                    <img :src="defi.imageSrc" class="img-fluid corner-cutted" :alt="defi.imageAlt" />
                  </div>
                  <div class="col-md-9 col-lg-10">
                    <h3>
                      <!-- .titre -->
                      <span>Défi {{ defiIndex + 1 }}&nbsp;: </span><span v-html="defi.titre"></span>
                    </h3>
                    <p class="mb-2">
                      <em>Milieu&nbsp;: <span v-html="defi.milieu"></span></em>
                    </p>
                    <!-- .html -->
                    <div v-if="defi.html" v-html="defi.html"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .imageSrc .imageAlt -->
            <div class="d-none d-md-block col-md-4 col-lg-3 mx-auto" v-if="section.imageSrc">
              <img :src="section.imageSrc" class="img-fluid corner-cutted" :alt="section.imageAlt" />
            </div>
          </div>
        </div>
      </div>

      <!-- Section info supp -->
      <div class="section-container">
        <span class="section-num" aria-hidden="true">{{ currentFiche.sections.length + 1 }}</span>

        <div class="section-area">
          <!-- .titre -->
          <h2>Informations supplémentaires</h2>
          <!-- DESKTOP VIEW (MD AND UP) -->
          <table class="table infoSuppTable d-none d-md-block">
            <thead>
              <tr>
                <th scope="col"><span v-html="currentFiche.infoSupp[0].titre"></span></th>
                <th scope="col"><span v-html="currentFiche.infoSupp[1].titre"></span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <!-- .bullets -->
                  <ul v-if="currentFiche.infoSupp[0].bullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].bullets" :key="bulletIndex" v-html="bullet"></li>
                  </ul>
                  <!-- .linkBullets -->
                  <ul v-if="currentFiche.infoSupp[0].linkBullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].linkBullets" :key="bulletIndex">
                      <a :href="bullet.link" target="_blank" :aria-label="bullet.text + ' (lien externe)'"><span v-html="bullet.text"></span>&nbsp;<font-awesome-icon title="Lien externe" icon="external-link-alt"/></a>
                    </li>
                  </ul>
                </td>
                <td>
                  <!-- .bullets -->
                  <ul v-if="currentFiche.infoSupp[1].bullets">
                    <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[1].bullets" :key="bulletIndex" v-html="bullet"></li>
                  </ul>
                  <!-- .linkBullets -->
                  <ul v-if="currentFiche.infoSupp[1].linkBullets">
                    <li v-for="linkBullet in currentFiche.infoSupp[1].linkBullets" :key="linkBullet.text">
                      <router-link :to="getPageLink(linkBullet.link)">{{ linkBullet.text }}</router-link>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- MOBILE VIEW (XS AND SM) -->
          <div class="infoSuppTable d-md-none">
            <h3 v-html="currentFiche.infoSupp[0].titre"></h3>
            <!-- .bullets -->
            <ul v-if="currentFiche.infoSupp[0].bullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].bullets" :key="bulletIndex" v-html="bullet"></li>
            </ul>
            <!-- .linkBullets -->
            <ul v-if="currentFiche.infoSupp[0].linkBullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[0].linkBullets" :key="bulletIndex">
                <a :href="bullet.link" target="_blank" :aria-label="bullet.text + ' (lien externe)'"><span v-html="bullet.text"></span>&nbsp;<font-awesome-icon title="Lien externe" icon="external-link-alt"/></a>
              </li>
            </ul>
            <h3 v-html="currentFiche.infoSupp[1].titre"></h3>
            <!-- .bullets -->
            <ul v-if="currentFiche.infoSupp[1].bullets">
              <li v-for="(bullet, bulletIndex) in currentFiche.infoSupp[1].bullets" :key="bulletIndex" v-html="bullet"></li>
            </ul>
            <!-- .linkBullets -->
            <ul v-if="currentFiche.infoSupp[1].linkBullets">
              <li v-for="linkBullet in currentFiche.infoSupp[1].linkBullets" :key="linkBullet.text">
                <router-link :to="getPageLink(linkBullet.link)">{{ linkBullet.text }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
export default {
  components: {
    ProgressBars,
    VideoPlayer,
  },
  props: {
    ficheId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      currentFiche: [],
      // Exemple de fiches
      // fichesEG: [
      //   {
      //     id: "",
      //     sujetCible: "",
      //     titre: "",
      //     sections: [
      //       {
      //         titre: "",
      //         bullets: ["", ""],
      //         linkBullets: [
      //           {
      //             text: "",
      //             link: "",
      //           },
      //           // ...
      //         ],
      //         html: ``,
      //         defis: [
      //           {
      //             titre: "",
      //             milieu: "",
      //             html: ``,
      //             // imageSrc: require("@/assets/fiches/cap1/AdobeStock_.jpeg"),
      //             imageAlt: "",
      //           },
      //           // ...
      //         ],
      //         // imageSrc: require("@/assets/fiches/cap1/"),
      //         imageAlt: "",
      //       },
      //       // ...
      //     ],
      //     infoSupp: [
      //       {
      //         titre: "",
      //         bullets: ["", ""],
      //         linkBullets: [
      //           {
      //             text: "",
      //             link: "",
      //           },
      //           // ...
      //         ],
      //         html: ``,
      //         // imageSrc: require("@/assets/fiches/cap1/"),
      //         imageAlt: "",
      //       },
      //       // ...
      //     ],
      //   },
      //   // ...
      // ],
      fiches: [
        // Fiche 1
        {
          sujetCible: "Les relations authentiques",
          titre: "Bien-être",
          sections: [
            // Seciton 1
            {
              titre: "Objectifs de la CAP",
              bullets: ["Comprendre l’importance de créer une relation de confiance avec l’enfant.", "Décrire l’impact d’une approche bienveillante et authentique sur le développement de l’enfant."],
              imageSrc: require("@/assets/fiches/cap1/AdobeStock_265794447.jpeg"),
              imageAlt: "",
            },
            // Seciton 2
            {
              titre: "Déclencheur",

              fullscreenImageSrc: require("@/assets/fiches/cap1/BD_attachement.png"),
              fullscreenImageAlt: "Trois vignettes : visage d'une petite fille fatiguée; père qui prend sa fille dans ses bras; petite fille souriant, énergisée.",
              // video: {
              //   titre: "L’attachement en cinq secondes – YouTube",
              //   isYoutubeVideo: "no", //or "yes"
              //   videoUrl: "https://cdn.jwplayer.com/videos/Yo3gQ9dv-WssBGIND.mp4",
              //   poster: "https://cdn.jwplayer.com/thumbs/Yo3gQ9dv-480.jpg",
              //   transcription: "/videos/cap1/video1.txt",
              // },
              // attachement: {
              //   imageSrc: require("@/assets/fiches/cap1/BD_attachement.png"),
              //   imageAlt: "",
              // },
            },
            // Seciton 3
            {
              titre: "Bonnes pratiques en lien avec le sujet de la CAP",
              bullets: ["Prendre le temps de développer des relations authentiques est un investissement à long terme qui bénéficiera à l’enfant tout au long de sa vie. ", "Tenir compte des besoins, des champs d’intérêt et du degré de développement de chaque enfant, permet de mieux la ou le connaître, donc de mieux l’accompagner.", "Permettre aux enfants de contribuer au monde qui les entoure et de participer pleinement à chaque étape du processus d’apprentissage, favorise la confiance en soi et multiplie les occasions d’apprentissage."],
              imageSrc: require("@/assets/fiches/cap1/AdobeStock_263142185.jpeg"),
              imageAlt: "",
            },
            // Seciton 4
            {
              titre: "Questions de réflexion",
              bullets: ["Selon toi, qu’est-ce qui définit une relation authentique et bienveillante?", "Selon toi, quels sont les bienfaits de créer une relation de confiance avec chaque enfant?", "Comment t’y prends-tu pour créer des relations authentiques avec chaque enfant pour lui permettre de refaire le plein d’énergie? ", "Quels exemples d’expériences de relations authentiques que tu as ou que tu as déjà eues avec un enfant, qui t’ont permis de l’accompagner dans ses apprentissages, pourrais-tu communiquer aux autres? Quel en a été l’impact sur son développement? "],
              imageSrc: require("@/assets/fiches/cap1/MES_Background.png"),
              imageAlt: "",
            },
          ],
          infoSupp: [
            // infoSupp 1
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "La roue des émotions",
                  link: "https://drive.google.com/file/d/15NR5ZaegzU8T_PkgoLSeEVYqVm8CyJ9n/view",
                },
                {
                  text: "Penser, sentir, agir",
                  link: "https://files.ontario.ca/edu-think-feel-act-lessons-from-research-about-young-children-fr-2021-01-29.pdf",
                },
                {
                  text: "Le pouvoir des relations positives entre l’adulte et l’enfant&nbsp;: la connexion est le facteur clé",
                  link: "https://drive.google.com/file/d/1_pAqJKLo1NuCH1A8QjRv8H1q6_NKfA3A/view ",
                },
                {
                  text: "À quoi ressemble une relation sensible et attentive?",
                  link: "https://drive.google.com/file/d/1-DzSWihhDIuHKofytcDD-e8kE4WrPa14/view?usp=sharing",
                },
                {
                  text: "Comment apprend-on?",
                  link: "https://files.ontario.ca/edu-how-does-learning-happen-fr-2021-03-23.pdf",
                },
              ],
            },
            // infoSupp 2
            {
              titre: "Mises en situation du jeu liées à la CAP",
              linkBullets: [
                {
                  text: "L’expression sous toutes ses formes",
                  link: {
                    situation: 8,
                    page: "video",
                  },
                },
                {
                  text: "Un milieu stimulant et inclusif pour toutes et tous",
                  link: {
                    situation: 2,
                    page: "video",
                  },
                },
                {
                  text: "Nature et découverte",
                  link: {
                    situation: 4,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // Fiche 2
        {
          sujetCible: "L’apprentissage par l’exploration, le jeu et l’enquête.",
          titre: "Expression",
          sections: [
            // Section 1
            {
              titre: "Objectifs de la CAP",
              bullets: ["Discuter de la place que l’exploration, le jeu et l’enquête tiennent dans notre pratique quotidienne.", "Déterminer la place que l’on voudrait donner à l’exploration, au jeu et à l’enquête. ", "Définir son rôle d’accompagnement et de coapprentissage."],
              imageSrc: require("@/assets/fiches/cap2/AdobeStock_348345239.jpeg"),
              imageAlt: "",
            },
            // Section 2
            {
              titre: "Déclencheur/Brise glace",
              html: `<p>Proposer aux personnes participantes de créer une invitation à l’apprentissage qui piquerait leur curiosité.</p>`,
            },
            // Section 3
            {
              titre: "Bonnes pratiques en lien avec le sujet de la CAP",
              bullets: ["S’impliquer dans le jeu des enfants nous permet de les accompagner de façon intentionnelle et significative.", "Mettre à profit toutes les occasions d’apprentissage qui se présentent à chaque moment de la journée, à chaque interaction et à chaque événement.", "Voir le monde avec les yeux de l’enfant grâce à l’écoute, au questionnement et à l’observation."],
              imageSrc: require("@/assets/fiches/cap2/AdobeStock_215717753.jpeg"),
              imageAlt: "",
            },
            // Section 4
            {
              titre: "Questions de réflexion",
              bullets: ["Comment aligner la vision du jeu et de l’enquête en tant qu’équipe?", "Comment peux-tu accompagner l’enfant dans son jeu?", "Comment peux-tu trouver un équilibre entre le jeu libre et les activités (invitations à l’apprentissage) plus structurées? ", "Quelles nouvelles pratiques pourrais-tu mettre en place afin d’offrir aux enfants plus d’occasions d’explorer librement le monde qui les entoure?", "Comment vois-tu ton rôle en ce qui a trait à l’accompagnement et au coapprentissage?"],
              imageSrc: require("@/assets/fiches/cap2/AdobeStock_245360474.jpeg"),
              imageAlt: "",
            },
          ],
          infoSupp: [
            // infoSupp 1
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Libres et créatifs – YouTube",
                  link: "https://lien.cforp.ca/31531",
                },
                {
                  text: "L’apprentissage par le jeu",
                  link: "https://lien.cforp.ca/31532",
                },
                {
                  text: "Coup d’œil sur le jeu extérieur – Se connecter à la nature",
                  link: "https://lien.cforp.ca/31533",
                },
                {
                  text: "Le jeu libre des enfants – Énoncé de position – Mars 2019",
                  link: "https://lien.cforp.ca/31534",
                },
                {
                  text: "Comment apprend-on?",
                  link: "https://lien.cforp.ca/31535",
                },
              ],
            },
            // infoSupp 2
            {
              titre: "Mises en situation du jeu liées à la CAP",
              linkBullets: [
                {
                  text: "On joue dehors!",
                  link: {
                    situation: 7,
                    page: "video",
                  },
                },
                {
                  text: "L’écoute visible.",
                  link: {
                    situation: 1,
                    page: "video",
                  },
                },
                {
                  text: "Prête ou prêt pour l'école, prête ou prêt pour la vie!",
                  link: {
                    situation: 10,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // Fiche 3
        {
          sujetCible: "L’environnement comme troisième éducateur",
          titre: "Appartenance",
          sections: [
            // Section 1
            {
              titre: "Objectifs de la CAP",
              bullets: ["Relever les éléments de l’environnement favorisant les apprentissages.", "Montrer la façon dont l’environnement peut influencer le développement des enfants."],
              imageSrc: require("@/assets/fiches/cap3/AdobeStock_248470038.jpeg"),
              imageAlt: "",
            },
            // Section 2
            {
              titre: "Déclencheur",
              html: `<p>En équipe, illustrer, à l’aide d’un mode d’expression au choix, la vision d’un environnement qui comprend tous les éléments essentiels au bon développement des enfants (dessin, maquette, peinture, poème, etc.) et la présenter.</p>`,
            },
            // Section 3
            {
              titre: "Bonnes pratiques en lien avec le sujet de la CAP",
              bullets: ["Utiliser des matériaux divers et polyvalents qui favorisent le développement de la créativité des enfants et qui répondent à leur propre questionnement quant à l’apprentissage.", "Créer un environnement propice aux apprentissages passe par les milieux physiques, mais aussi par les relations et nos interactions avec les enfants, leurs familles et nos collègues de travail.", "Se questionner sur la qualité de tous les environnements intérieurs et extérieurs dans lesquels évoluent les enfants."],
              imageSrc: require("@/assets/fiches/cap3/AdobeStock_441949482.jpeg"),
              imageAlt: "",
            },
            // Section 4
            {
              titre: "Questions de réflexion",
              bullets: ["Que signifie concrètement pour toi l’expression «  l’environnement comme troisième enseignant  »?", "De quelle manière rends-tu cette expression vivante dans ta pratique?", "Comment t’assures-tu que l’environnement est riche en occasions d’apprentissage et de découvertes?", "Quelles modifications pourrais-tu apporter à l’environnement des enfants et à tes pratiques quotidiennes pour que les enfants aient accès à de multiples occasions d’apprentissage? Pense à l’environnement intérieur, à la cour extérieure, au-delà de la cour extérieure (nature, communauté, etc.).", "Comment est-ce que les enfants peuvent contribuer à transformer leur propre environnement de jeu?"],
              imageSrc: require("@/assets/fiches/cap3/AdobeStock_238923438.jpeg"),
              imageAlt: "",
            },
          ],
          infoSupp: [
            // infoSupp 1
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Comment apprend-on?",
                  link: "https://lien.cforp.ca/31536",
                },
                {
                  text: "L’environnement en tant qu’éducateur",
                  link: "https://lien.cforp.ca/31537",
                },
                {
                  text: "Reggio Emilia Approach 1 – YouTube",
                  link: "https://lien.cforp.ca/31538",
                },
                {
                  text: "Reggio Emilia Loose Parts Provocation – YouTube",
                  link: "https://lien.cforp.ca/31539",
                },
              ],
            },
            // infoSupp 2
            {
              titre: "Mises en situation du jeu liées à la CAP",
              linkBullets: [
                {
                  text: "Explorons le jeu aventureux!",
                  link: {
                    situation: 11,
                    page: "video",
                  },
                },
                {
                  text: "Un environnement riche en expériences d’apprentissage!",
                  link: {
                    situation: 5,
                    page: "video",
                  },
                },
                {
                  text: "Cultiver de saines habitudes de vie",
                  link: {
                    situation: 6,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
        // Fiche 4
        {
          sujetCible: "L’engagement familial",
          titre: "Engagement",
          sections: [
            // Section 1
            {
              titre: "Objectifs de la CAP",
              bullets: ["Définir l’importance de créer des liens authentiques et bienveillants avec les familles.", "Déterminer les actions nécessaires pour favoriser l’engagement des familles."],
              imageSrc: require("@/assets/fiches/cap4/AdobeStock_289101851.jpeg"),
              imageAlt: "",
            },
            // Section 2
            {
              titre: "Déclencheur",
              html: `<p>Demander aux personnes participantes d’écrire, sur un papier, une tradition suivie ou une activité faite dans leur famille. Mettre les papiers dans un bol, en tirer un au hasard et faire deviner à qui appartient la tradition. S’il s’agit d’une activité via Internet, poser la question avant la rencontre et la personne qui anime l’activité pourra les lire en ligne.</p>`,
            },
            // Section 3
            {
              titre: "Bonnes pratiques en lien avec le sujet de la CAP",
              bullets: ["Prendre le temps de créer des relations solides avec les familles est la première étape vers l’engagement familial.", "Favoriser le développement d’un sentiment d’appartenance chez les familles par un accueil chaleureux.", "Encourager l’engagement familial par nos relations et nos actions, en offrant des occasions de contribuer au développement des enfants et en considérant la famille comme le premier éducateur des enfants."],
              imageSrc: require("@/assets/fiches/cap4/AdobeStock_44428934.jpeg"),
              imageAlt: "",
            },
            // Section 4
            {
              titre: "Questions de réflexion",
              bullets: ["Quel rôle jouent les familles dans les programmes de la petite enfance? Quelles valeurs ajoutées peuvent-elles apporter?", "Que signifie l’engagement familial?", "De quelle manière est-ce visible dans votre programme?", "Pour quelles raisons est-il important de créer des liens authentiques et bienveillants avec les familles?", "Quelles actions concrètes peuvent être mises en œuvre afin d’assurer un réel engagement des familles dans les centres éducatifs à l’enfance?"],
              html: ``,
              imageSrc: require("@/assets/fiches/cap4/AdobeStock_249958779.jpeg"),
              imageAlt: "",
            },
          ],
          infoSupp: [
            // infoSupp 1
            {
              titre: "Ressources additionnelles pour aller plus loin",
              linkBullets: [
                {
                  text: "Communiquer et collaborer avec les familles",
                  link: "https://lien.cforp.ca/31540",
                },
                {
                  text: "Comment apprend-on ? Pédagogie de l’Ontario pour la petite enfance",
                  link: "https://lien.cforp.ca/31541",
                },
                {
                  text: "Autoformation portant sur le bien-être",
                  link: "https://lien.cforp.ca/31542",
                },
                {
                  text: "L’apprentissage par l’exploration, le jeu et l’enquête",
                  link: "https://lien.cforp.ca/31543",
                },
              ],
            },
            // infoSupp 2
            {
              titre: "Mises en situation du jeu liées à la CAP",
              linkBullets: [
                {
                  text: "L’accueil des familles",
                  link: {
                    situation: 0,
                    page: "video",
                  },
                },
                {
                  text: "Ici, je suis chez moi",
                  link: {
                    situation: 3,
                    page: "video",
                  },
                },
                {
                  text: "À la découverte de ma communauté…",
                  link: {
                    situation: 9,
                    page: "video",
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    getPageLink(link) {
      return `/${this.getMatchedAreaName(link.situation)}/${this.getSituationNameFromSituationIndex(link.situation)}/${link.page}`;
    },
  },

  created() {
    if (this.ficheId != undefined) {
      this.currentFiche = this.fiches[this.ficheId];
    }
  },
};
</script>

<style scoped>
span + span {
  margin-left: 0px;
}
h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}
h2 {
  font-size: 1.35rem !important;
  color: #000;
}
h3 {
  font-size: 1.35rem !important;
  color: #154f68 !important;
}

.section-container {
  position: relative;
  margin-top: 24px;
  /* width: 95%; */
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.section-area {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  /* color: #374a66 !important; */
  color: #1f2d4c !important;
  font-size: 17px;
  padding: 20px 25px 25px 25px;

  width: 94%;
  margin-left: auto;
}
@media (max-width: 1000px) {
  .section-area {
    width: 91.5%;
  }
}
@media (max-width: 807px) {
  .section-area {
    width: 100%;
  }
  .section-num {
    display: none;
  }
}
.section-num {
  position: absolute;
  top: 5px;
  left: 0px;

  font-size: 1.6rem;
  font-weight: 600;

  padding-left: 13px;
  padding-right: 13px;
  padding-bottom: 3px;

  background-color: #154f68;
  color: #fff;
  border: solid 7px #fff;
  border-radius: 50%;

  font-variant-numeric: tabular-nums;
}
.section-area img.corner-cutted {
  border-radius: 15px;
}
.section-area ul {
  list-style: none; /* Remove default bullets */
}

.section-area ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #5aa9af; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}
@media reader, speech, aural {
  .section-area ul li::before {
    display: none !important;
    visibility: hidden !important;
  }
}
.attachement {
  background-color: #fff;
  margin-left: -26px;
  margin-right: -26px;
  padding-left: 11px;
  padding-right: 11px;

  padding-bottom: 30px;

  margin-bottom: -38px;

  border-end-end-radius: 53px;
  border-end-start-radius: 53px;
}
.attachement h3 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.video-section {
  padding-top: 10px;
  padding-bottom: 35px;
}
.defi-wrapper {
  margin-top: 10px;
}
.defi-box {
  padding-top: 15px;
  padding-bottom: 15px;

  margin-left: -26px;
  margin-right: -26px;

  padding-left: 11px;
  padding-right: 11px;
}
.defi-box:nth-child(odd) {
  background-color: #fff;
}
.infoSuppTable {
  margin-top: 15px;
  width: 100%;
}
.infoSuppTable th {
  background-color: #154f68;
  padding: 20px;
  text-align: center;
  width: 50%;
}
.infoSuppTable th span {
  color: #fff;
  font-weight: 500;
  max-width: 250px;
  display: inline-block;
}
.infoSuppTable td:nth-child(1) {
  border-right: solid 2px #154f68;
}
.infoSuppTable td {
  padding-top: 12px;
  padding-right: 20px;
  vertical-align: top;
}
.infoSuppTable li {
  padding-top: 7px;
}

.infoSuppTable a {
  color: #1f2d4c !important;
  text-decoration: underline !important;
}

.infoSuppTable h3 {
  font-size: 1rem !important;
  color: #fff !important;
  background-color: #154f68;
  padding: 15px;
  font-weight: 500;
}
</style>
